import { render, staticRenderFns } from "./DoughnutChartEngagement.vue?vue&type=template&id=495ded90&scoped=true&"
import script from "./DoughnutChartEngagement.vue?vue&type=script&lang=js&"
export * from "./DoughnutChartEngagement.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChartEngagement.vue?vue&type=style&index=0&id=495ded90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ded90",
  null
  
)

export default component.exports